import { render, staticRenderFns } from "./Criticidade.vue?vue&type=template&id=b7dcc51a&lang=pug"
import script from "./Criticidade.vue?vue&type=script&lang=js"
export * from "./Criticidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports